import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchProduct } from '@/services/product/product.type';
import { ApiResponse } from '../sagas/locationSaga';

export interface ProductState {
  product: ApiResponse;
  loading: boolean;
  error: boolean;
}

export const initialState: ProductState = {
  product: {
    data: [],
    pagination: {
      totalRecords: 0,
      totalItems: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: '',
  },
  loading: false,
  error: false,
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    getProducts: (state, action: PayloadAction<IFetchProduct>) => {
      state.loading = true;
    },
    getProductsSuccess: (state, action: PayloadAction<ApiResponse>) => {
      state.loading = false;
      state.product = { ...action.payload };
    },
    getProductsFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
      state.product = { ...initialState?.product };
    },
  },
});

const productReducer = productSlice?.reducer;

export const { getProducts, getProductsSuccess, getProductsFailure } =
  productSlice?.actions;

export default productReducer;
